// eslint-disable-next-line import/prefer-default-export
export const UPDATE_CASHUP_DATA = 'UPDATE_CASHUP_DATA';
